/*
 * The dead-end screen for a token that grants no section at all (section-access.ts).
 * Shared by every guarded route so a permission-less operator always lands on the same
 * "log out and get your role reviewed" surface, whichever route they hit.
 */
import { Button, EmptyState } from '@cou/admin-ui';
import { useAdminAuth } from '../session/admin-auth-context';
import { AdminShell } from './AdminShell';

export function NoAccessScreen() {
  const { signOut } = useAdminAuth();
  return (
    <AdminShell title="No access">
      <EmptyState
        variant="page"
        title="No sections available"
        body="This account has no permitted sections. Ask a Super Admin to review your role."
        action={
          <Button variant="outline" onClick={signOut}>
            Log out
          </Button>
        }
      />
    </AdminShell>
  );
}
